import React from 'react';
import { Link } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilCaretRight } from '@coreui/icons';
import { CCard, CCardBody } from '@coreui/react';

/**
 * Recent payments widget showing latest transactions
 */
const RecentPaymentsWidget = () => {
  // Mock data - replace with your actual data
  const recentPayments = [
    { email: 'michael@stripe.com', amount: 250.00 },
    { email: 'jessica@stripe.com', amount: 250.00 },
    { email: 'david@stripe.com', amount: 54.32 }
  ];

  return (
    <CCard className="recent-payments-widget">
      <CCardBody>
        <div className="widget-header">
          <h3 className="widget-title">Recent payments</h3>
          <Link 
            to="/dashboard/creator/payments" 
            className="view-all-link"
          >
            View all
            <CIcon icon={cilCaretRight} size="sm" className="ms-1" />
          </Link>
        </div>
        
        <ul className="payments-list">
          {recentPayments.map((payment, index) => (
            <li key={index} className="payment-item">
              <span className="payment-email">{payment.email}</span>
              <span className="payment-amount">
                ${payment.amount.toFixed(2)}
              </span>
            </li>
          ))}
        </ul>
      </CCardBody>
    </CCard>
  );
};

export default RecentPaymentsWidget; 